import { motion } from "framer-motion";

export default function Capabilities({ capabilities, hero }) {
  return (
    <section id="capabilities" className="bg-[#161B22]/50 border-y border-white/5" data-testid="capabilities-section">
      <div className="max-w-7xl mx-auto px-6 py-20 lg:py-28 grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <p className="text-xs sm:text-sm font-bold uppercase tracking-[0.2em] text-[#FF5A1F]" data-testid="capabilities-eyebrow">Sublimation & Manufacturing</p>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="capabilities-heading">
            Industrial print. In-house production.
          </h2>
          <p className="mt-4 text-base md:text-lg text-slate-400 leading-relaxed">
            Everything happens under one roof — printing, cutting, stitching and finishing — so quality and deadlines stay in our hands, not a third party's.
          </p>
          <div className="mt-10 space-y-6">
            {capabilities.map((c, i) => (
              <motion.div key={c.title}
                initial={{ opacity: 0, x: -20 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.1 }}
                className="flex gap-5 bg-[#161B22] border border-white/10 rounded-2xl p-6"
                data-testid={`capability-card-${i}`}>
                <img src={c.image} alt={c.title} loading="lazy" className="h-16 w-16 rounded-xl object-cover shrink-0" />
                <div>
                  <h3 className="font-heading text-lg font-bold">{c.title}</h3>
                  <p className="mt-1 text-sm text-slate-400 leading-relaxed">{c.text}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
        <motion.div
          initial={{ opacity: 0, scale: 0.96 }} whileInView={{ opacity: 1, scale: 1 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
          className="relative rounded-3xl overflow-hidden border border-white/10 aspect-[4/5] lg:aspect-[4/4.6]"
          data-testid="factory-media">
          {hero.video_url ? (
            <video src={hero.video_url} autoPlay muted loop playsInline poster={hero.image}
              className="w-full h-full object-cover" data-testid="factory-video" />
          ) : (
            <img src={capabilities[0]?.image || hero.image} alt="Sublimation printing facility"
              className="w-full h-full object-cover animate-kenburns" />
          )}
          <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0D0F12] to-transparent p-8">
            <p className="font-heading text-xl font-bold">Factory floor, AZ Concepts</p>
            <p className="mt-1 text-sm text-slate-300">Sublimation presses & cut-and-sew lines in daily production</p>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
